const localStorage = {}

localStorage.get = (key) => {
    return window.localStorage.getItem(key) || '';
}

localStorage.set = (key, val) => {
    if (!key){
        return;
    }

    let value;
    if (typeof val == 'object'){
        value = JSON.stringify(val);
    } else {
        value = val;
    }

    window.localStorage.setItem(key, value);
}

localStorage.remove = (key) => {
    window.localStorage.removeItem(key);
},


localStorage.clear = () => {
    window.localStorage.clear();
}

localStorage.getAll = () => {
    return window.localStorage;
}

export default localStorage;

